import ReactGA from 'react-ga4';

const runGA4 = false

export const handleGA4PageHit = (data: { page: string, title: string }) => {
	if (runGA4) {
		ReactGA.send({
			hitType: 'pageview',
			page: data.page,
			title: data.title
		});
	}
}

export const handleGA4Event = (data: { category: string, action: string, label: string }) => {
	if (runGA4) {
		ReactGA.event({
			category: data.category,
			action: data.action,
			label: data.label
		})
	}
}